import type { BrowserNotificationRuntime } from './browser-notification-runtime'
import { isHostedArenaHostname } from './arena'

export type ArenaServiceWorkerRegistration
  = | {
    status: 'registered'
    registration: ServiceWorkerRegistration
  }
  | {
    status: 'skipped'
    reason: 'non-arena-origin' | 'service-worker-unavailable'
  }

export interface ArenaServiceWorkerRegistrationOptions {
  localArena?: boolean
}

export async function registerArenaServiceWorker(
  runtime: BrowserNotificationRuntime,
  options: ArenaServiceWorkerRegistrationOptions = {},
): Promise<ArenaServiceWorkerRegistration> {
  const isLocalhost
    = runtime.hostname === 'localhost' || runtime.hostname === '127.0.0.1'
  if (
    !isHostedArenaHostname(runtime.hostname)
    && !(options.localArena && isLocalhost)
  ) {
    return {
      status: 'skipped',
      reason: 'non-arena-origin',
    }
  }

  if (!runtime.readCapabilities().serviceWorker) {
    return {
      status: 'skipped',
      reason: 'service-worker-unavailable',
    }
  }

  const registration = await runtime.registerServiceWorker(
    '/service-worker.js',
    { scope: '/', updateViaCache: 'none' },
  )

  return { status: 'registered', registration }
}
